module.exports = __webpack_public_path__ + "static/img/default_photo3.fb5b70cc.png";